import {SURVEY_OPTION_TYPE} from '@/common/consts/survey.js';
import {digitToBoolean} from '@/iamteacherpc/utils/convertBoolean.js';

/**
 * 설문 참여 거절 옵션 여부
 * @param surveyOptionList
 * @returns {boolean}
 */
export function isAllowDeny({surveyOptionList}) {
    const allowDenyOption = surveyOptionList.find(option => option.optionType === SURVEY_OPTION_TYPE.ALLOW_DENY);
    if (!allowDenyOption) {
        return true;
    }
    return digitToBoolean(allowDenyOption.optionValue);
}

/**
 * 응답자 회신 후 수정 옵션 여부
 * @param surveyOptionList
 * @returns {boolean}
 */
export function isAllowEdit({surveyOptionList}) {
    const allowEditOption = surveyOptionList.find(option => option.optionType === SURVEY_OPTION_TYPE.ALLOW_EDIT);
    if (!allowEditOption) {
        return true;
    }
    return digitToBoolean(allowEditOption.optionValue);
}
